import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { partnerListQuery } from "@/features/partners/api";
import { PartnersPage } from "@/features/partners/PartnersPage";
import { validatePartnerSearch, type PartnerSearch } from "@/features/partners/search";
import { partnerListColumns } from "@patronix/domain/list";
import { viewQuery } from "@/lib/listView";

// Master data → Business partners: every partner, or the Customers / Suppliers
// view (role; the old Sales / Procurement screens redirect here, ADR-046).
export const Route = createFileRoute("/_app/master-data/partners")({
  validateSearch: validatePartnerSearch,
  loaderDeps: ({ search }) => ({ role: search.role, q: search.q, inactive: search.inactive, f: search.f, s: search.s }),
  loader: ({ context, deps }) => context.queryClient.ensureInfiniteQueryData(partnerListQuery({ role: deps.role ?? "all", q: deps.q, inactive: deps.inactive, ...viewQuery(partnerListColumns, deps) })),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<PartnerSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <PartnersPage role={search.role ?? "all"} search={search} setSearch={setSearch} roleSwitch />;
}
